import * as React from "react";
import type { SVGProps } from "react";
const SvgExpand02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.01 10.99 6.061-6.061m0 0h-4.04m4.04 0v4.04M10.99 13.01l-6.06 6.061m0 0h4.04m-4.04 0v-4.04m8.08-2.02 6.061 6.06m0 0v-4.04m0 4.04h-4.04m-4.04-8.082L4.928 4.93m0 0v4.04m0-4.04h4.04"
    />
  </svg>
);
export default SvgExpand02;
